module.exports = __webpack_public_path__ + "static/img/LAZADA.2d48a497.png";